const setLoadResource = (data) => ({
  type: "LOADING_RESOURCE",
  data: data
})

export { setLoadResource }